<template>
  <div :style="style">
    <b-carousel
      v-if="urls.length > 1"
      id="carousel-1"
      v-model="slide"
      :interval="interval"
      controls
      indicators
      background="#ababab"
      :img-height="height"
      style="text-shadow: 1px 1px 2px #333;"
      :style="style"
      @sliding-start="onSlideStart"
      @sliding-end="onSlideEnd"
    >
      
      <b-carousel-slide v-for="(item,index) in urls">
        <template v-slot:img>
          <img
            class="d-block img-fluid w-100"
            :src="item.url"
            alt="image slot"
          >
        </template>
      </b-carousel-slide>
    </b-carousel>
    <banner v-if="urls.length == 1" :layout="'img'" :url="urls[0].url"  :height="'auto'" :action="action" @on-button="$emit('on-button',$enevt)"></banner>
  </div>
    
        
    
  </template>
  
  <script>
  
import store from '@/store'

import banner from '@/components/banner.vue'
// import banner from '@/assets/banner1.png'

  export default {
    name: 'carousel',
    components:{banner},
    props: {
        initUrls:{
            type:[String,Array],
            default(){
                return [] // url
            }
        },
        height:{
            type:[String,Number],
            default(){
                return 300 // url
            }
        },
        interval:{
            type:[String,Number],
            default(){
                return 3000 // url
            }
        },
        activeNavbar:{
          type:[String],
            default(){
                return '' // url
            }
        },
        action:{
          type:[Object],
            default(){
                return null
                // {
                //   text:'',
                //   type:'',
                //   params:null,

                // }
            }
        }
    },
    computed:{
        style(){
            let style = {}
            let height = this.height
            if(height){
                style['height'] = `${height}px`
                    style['max-height'] = `${height}px`
                    style['mix-height'] = `${height}px`
                    style['overflow'] = `hidden`
            }
            return style
        },
        urls(){
          let imgs = store.getters.getActiveCarousel || []
          let urls = []
          let config = this.webConfig
          let hostPath =  `${config.protocol}://${config.host}${config.port?':'+config.port:''}${config.prefix}`
          // if(process.env.NODE_ENV === 'development'){
          //   hostPath = config.prefix
          // }else{
          //   hostPath = `${config.protocol}://${config.host}${config.port?':'+config.port:''}${config.prefix}`
          // }
          if(this.activeNavbar){
            for(let img of imgs){
              let url = this.getFileUrls(img.carousel_img)
              let obj = {
                url:hostPath + `/file/download?fileNo=${img.carousel_img}`,
                href:'',
                '_data':img
              }
              urls.push(obj)
            }
          }else if(this.initUrls.length > 0){
            urls = this.initUrls.map(item => item)
          }
          
          return urls
        }
    },
    mounted(){
        if(this.activeNavbar){
          this.getCarousel(this.activeNavbar)  
        }
        
    },
    data() {
      return {
        slide: 0,
        sliding: null
      }
    },
    methods: {
        onSlideStart(slide) {
            this.sliding = true
        },
        onSlideEnd(slide) {
            this.sliding = false
        },
        getCarousel(no){
           store.dispatch('getActiveNavAction',no)
        },
        onClick(e){
          this.$emit('on-button',e)
        }
    }
  }
  </script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
.card-img{
  min-height: 8rem;
}
  </style>
  